import React from 'react';
import CountUp from 'react-countup';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import SiteContentContext from '../../content/SiteContentContext';
import { getTranslations, getByPath, resolveMediaSrc } from '../../content/siteContentUtils';

var bgimg1 = require('./../../images/background/bg-8.jpg');
var bgimg2 = require('./../../images/background/bg-5.png');
var bgimg3 = require('./../../images/background/cross-line2.png');
var bgimg4 = require('./../../images/background/bg-12.jpg');

const fallbackNumbers = [
    { value: '24', suffix: '', label: 'Yıllık Tecrübe' },
    { value: '340', suffix: '', label: 'Tamamlanan Proje' },
    { value: '86', suffix: '', label: 'Memnun Müşteri' },
    { value: '36', suffix: 'K', label: 'Referanslar' }
];

const fallbackTestimonials = [
    { image: require('./../../images/testimonials/pic1.jpg'), name: 'Ahmet Yılmaz', role: 'Müşteri', quote: 'Müşteri hizmetleri çok ilgiliydi, kapımız tam zamanında geldi ve montaj kusursuz yapıldı. Teşekkürler Fırat Çelik Kapı.' },
    { image: require('./../../images/testimonials/pic2.jpg'), name: 'Ayşe Demir', role: 'Mimar', quote: 'Güvenlik benim için çok önemliydi, kullanılan malzeme ve kilit sistemleri gerçekten harika. Herkese tavsiye ederim.' },
    { image: require('./../../images/testimonials/pic3.jpg'), name: 'Mehmet Öz', role: 'İşletme Sahibi', quote: 'Ofisimiz için yangın kapıları sipariş ettik. Mevzuata uygun, sertifikalı ve çok kaliteli ürünler. Süreçten memnun kaldık.' },
    { image: require('./../../images/testimonials/pic4.jpg'), name: 'Zeynep Kaya', role: 'Ev Hanımı', quote: 'Evinizin girişini değiştirmek istiyorsanız doğru adres. Tasarım konusunda çok yardımcı oldular.' },
    { image: require('./../../images/testimonials/pic3.jpg'), name: 'Caner Erkin', role: 'Müteahhit', quote: 'Projelerimizde Fırat Çelik Kapı ile çalışıyoruz. Ürün kalitesi ve termin sürelerine uyumları çok iyi.' }
];

class Testimonials1 extends React.Component {
    static contextType = SiteContentContext;

    render() {
        const options = {
            loop: true,
            autoplay: true,
            margin: 30,
            autoplayTimeout: 6000,
            nav: false,
            dots: true,
            navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
            responsive: {
                0: { items: 1 },
                991: { items: 1 }
            }
        };

        const content = this.context?.content || {};
        const t = getTranslations(content);
        const numbersSection = t?.pages?.home?.numbers || {};
        const numbersItems = Array.isArray(numbersSection.items) ? numbersSection.items : [];
        const testimonialsSection = t?.pages?.home?.testimonials || {};
        const testimonialItems = Array.isArray(testimonialsSection.items) ? testimonialsSection.items : [];
        const testimonialImages = getByPath(content, 'media.pages.testimonialPeople', []);
        const numbersBgImage = resolveMediaSrc(getByPath(content, 'media.pages.homeNumbersBackground', ''), bgimg1);

        const mergedNumbers = fallbackNumbers.map((fallback, index) => ({ ...fallback, ...(numbersItems[index] || {}) }));
        const mergedTestimonials = fallbackTestimonials.map((fallback, index) => {
            const item = testimonialItems[index] || {};
            const media = (Array.isArray(testimonialImages) ? testimonialImages[index] : null) || {};
            return {
                image: resolveMediaSrc(media.imageUrl, fallback.image),
                reviewername: item.name || fallback.name,
                position: item.role || fallback.role,
                review: item.quote || fallback.quote,
            };
        });

        return (
            <>
                <div className="section-full container-fluid">
                    <div className="section-content">
                        <div className="row">
                            <div className="col-xl-6 col-lg-6 col-md-12 bg-gray bg-cover bg-no-repeat" style={{ backgroundImage: 'url(' + numbersBgImage + ')' }}>
                                <div className="sx-left-part mobile-page-padding">
                                    <div className="section-head">
                                        <div className="sx-separator-outer separator-left">
                                            <div className="sx-separator bg-white bg-moving bg-repeat-x" style={{ backgroundImage: 'url(' + bgimg3 + ')' }}>
                                                <h3 className="sep-line-one">{numbersSection.title || 'Rakamlarla Biz'}</h3>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="counter-blocks">
                                        <div className="row">
                                            {mergedNumbers.map((item, index) => {
                                                const endValue = Number(String(item.value || '0').replace(',', '.')) || 0;
                                                const suffix = item.suffix || '';
                                                return (
                                                    <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 m-b30" key={`number-card-${index}`}>
                                                        <div className="sx-count text-black sx-icon-box-wraper bg-repeat bg-white p-a30" style={{ backgroundImage: 'url(' + bgimg2 + ')' }}>
                                                            <h2 className="st-count-number sx-text-primary text-left"><span className="counter"><CountUp end={endValue} duration={5} /></span>{suffix ? <span>{suffix}</span> : null}</h2>
                                                            <h4 className="m-tb0">{item.label}</h4>
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-6 col-lg-6 col-md-12 bg-white bg-repeat" style={{ backgroundImage: 'url(' + bgimg4 + ')' }}>
                                <div className="sx-right-part mobile-page-padding  p-t80 p-b50">
                                    <div className="section-head">
                                        <div className="sx-separator-outer separator-left">
                                            <div className="sx-separator bg-white bg-moving bg-repeat-x" style={{ backgroundImage: 'url(' + bgimg3 + ')' }}>
                                                <h3 className="sep-line-one">{testimonialsSection.title || 'Müşteri Yorumları'}</h3>
                                            </div>
                                        </div>
                                    </div>
                                    <OwlCarousel className="owl-carousel testimonial-home number-slider" {...options}>
                                        {mergedTestimonials.map((item, index) => (
                                            <div className="item" key={index}>
                                                <div className="testimonial-2 hover-animation-1">
                                                    <div className="testimonial-detail clearfix">
                                                        <div className="testimonial-pic shadow scale-in-center"><img src={item.image} alt="" width={100} height={100} /></div>
                                                        <h4 className="testimonial-name">{item.reviewername}</h4>
                                                        <span className="testimonial-position">{item.position}</span>
                                                        <span className="fa fa-quote-right" />
                                                    </div>
                                                    <div className="testimonial-text bg-white shadow-sm">
                                                        <p>{item.review}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </OwlCarousel>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
};

export default Testimonials1;
